import {
	ADMINDELETECURRENCYMAPPING_SUCCESS,
	ADMINDELETECURRENCYMAPPING_FAILED,
	RESET_ADMINDELETECURRENCYMAPPING,
	LOADING_ADMINDELETECURRENCYMAPPING,
	NETWORK_ERROR_ADMINDELETECURRENCYMAPPING
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {},
	message: "",
	networkError: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINDELETECURRENCYMAPPING:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {},
				message: "",
				networkError: ""
			};
		case ADMINDELETECURRENCYMAPPING_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case ADMINDELETECURRENCYMAPPING_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case NETWORK_ERROR_ADMINDELETECURRENCYMAPPING:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {},
				message: "",
				networkError: ""
			};
		case RESET_ADMINDELETECURRENCYMAPPING:
			return (state = initialState);
		default:
			return state;
	}
};
